import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SurveyIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SurveyIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M9.30322 16.3633C7.05761 16.3633 5.23047 14.5361 5.23047 12.29C5.23047 10.044 7.05762 8.2168 9.30322 8.2168C11.5493 8.2168 13.3765 10.044 13.3765 12.29C13.3765 14.5361 11.5493 16.3633 9.30322 16.3633ZM9.30322 9.2168C7.60888 9.2168 6.23047 10.5957 6.23047 12.29C6.23047 13.9844 7.60889 15.3633 9.30322 15.3633C10.998 15.3633 12.3765 13.9844 12.3765 12.29C12.3765 10.5957 10.998 9.2168 9.30322 9.2168Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.5244 22.5C15.248 22.5 15.0244 22.2764 15.0244 22V20.7041C15.0244 19.5615 14.0952 18.6328 12.9531 18.6328H5.65332C4.51123 18.6328 3.58203 19.5615 3.58203 20.7041V22C3.58203 22.2764 3.3584 22.5 3.08203 22.5C2.80566 22.5 2.58203 22.2764 2.58203 22V20.7041C2.58203 19.0107 3.95996 17.6328 5.65332 17.6328H12.9531C14.6465 17.6328 16.0244 19.0107 16.0244 20.7041V22C16.0244 22.2764 15.8008 22.5 15.5244 22.5Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.9922 15.5225C14.9248 15.5225 14.8564 15.5088 14.7925 15.4805C14.6099 15.4014 14.4922 15.2217 14.4922 15.0225V12.79H12.8765C12.6001 12.79 12.3765 12.5664 12.3765 12.29C12.3765 12.0137 12.6001 11.79 12.8765 11.79H14.9922C15.2686 11.79 15.4922 12.0137 15.4922 12.29V13.876L17.5942 11.9238C17.687 11.8379 17.8086 11.79 17.9346 11.79H19.6562C20.3735 11.79 20.9575 11.2061 20.9575 10.4893V4.80078C20.9575 4.08398 20.3735 3.5 19.6562 3.5H4.8833C4.16601 3.5 3.58203 4.08398 3.58203 4.80078V10.4893C3.58203 11.2061 4.16601 11.79 4.8833 11.79C5.15967 11.79 5.3833 12.0137 5.3833 12.29C5.3833 12.5664 5.15967 12.79 4.8833 12.79C3.61426 12.79 2.58203 11.7578 2.58203 10.4893V4.80078C2.58203 3.53223 3.61426 2.5 4.8833 2.5H19.6563C20.9253 2.5 21.9575 3.53223 21.9575 4.80078V10.4893C21.9575 11.7578 20.9253 12.79 19.6563 12.79H18.1309L15.3325 15.3887C15.2383 15.4766 15.1157 15.5225 14.9922 15.5225Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.6826 6.69433H6.58496C6.30859 6.69433 6.08496 6.4707 6.08496 6.19433C6.08496 5.91796 6.30859 5.69433 6.58496 5.69433H17.6826C17.959 5.69433 18.1826 5.91796 18.1826 6.19433C18.1826 6.4707 17.959 6.69433 17.6826 6.69433Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.6826 9.21679H14.2353C13.959 9.21679 13.7353 8.99316 13.7353 8.71679C13.7353 8.44042 13.959 8.21679 14.2353 8.21679H17.6826C17.959 8.21679 18.1826 8.44042 18.1826 8.71679C18.1826 8.99316 17.959 9.21679 17.6826 9.21679Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SurveyIcon;
